/* Add JavaScript Here*/

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const serializeForm = (formElement) => {
  const obj = {};
  const formData = new FormData(formElement);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return obj;
};

const loadingSpinnerSvg = `<div class="inset-0 pointer-events-none absolute z-50 h-full w-full transition-all duration-75">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 2"
        preserveAspectRatio="xMidYMid"
        class="absolute left-1/2 top-1/2 h-full w-14 -translate-x-1/2 -translate-y-1/2 "
      >
        <g transform="translate(20 1)">
          <circle cx="0" cy="0" r="6" fill="currentColor">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.375s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
        </g>
        <g transform="translate(40 1)">
          <circle cx="0" cy="0" r="6" fill="currentColor">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.25s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
        </g>
        <g transform="translate(60 1)">
          <circle cx="0" cy="0" r="6" fill="currentColor">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.125s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
        </g>
        <g transform="translate(80 1)">
          <circle cx="0" cy="0" r="6" fill="currentColor">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="0s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
        </g>
      </svg>`;

document.addEventListener("DOMContentLoaded", async () => {
  if (!/\/collections\//gi.test(window.request_path)) return;
  const formElementIds = [];

  const observer = new MutationObserver((mutationEvent) => {
    mutationEvent?.forEach((record) =>
      record.addedNodes.forEach(async (node) => {
        if (node instanceof HTMLElement) {
          const formElement = node.querySelector(`form[action="/cart/add"]`);
          if (!formElement || formElementIds.includes(formElement.id)) return;
          formElementIds.push(formElement.id);
          const formButton = formElement.querySelector("button");
          const formButtonContent = formElement.querySelector("button span");

          formElement.addEventListener("submit", async (event) => {
            event.preventDefault();
            event.stopPropagation();
            const formData = serializeForm(formElement);
            const loadingElement = document.createElement("div");
            formButton.classList.add("relative");
            loadingElement.innerHTML = loadingSpinnerSvg;
            const loadingSpinner = loadingElement.querySelector("div");
            formButton.appendChild(loadingSpinner);
            formButtonContent.style.opacity = "0";
            await window.cart.add({ items: [formData] }, true);
            formButton.removeChild(loadingSpinner);
            formButtonContent.style.opacity = "";
          });
        }
      })
    );
  });
  observer.observe(document, {
    subtree: true,
    childList: true,
  });

  const bodyObserver = new MutationObserver((mutationEvent) => {
    mutationEvent?.forEach((record) => {
      if (
        record.attributeName === "class" &&
        document.body.classList.contains("rebuy-modal-visible")
      ) {
        document.body.classList.remove("rebuy-modal-visible");
      }
    });
  });
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeOldValue: true,
  });
});

/******* OCTAINE AI QUIZ ********/

function setFlexItemWidth(columns) {
  const gap = 10;
  const flexItems = document.querySelectorAll(".oct-quiz-products__item");
  const width = `calc(${100 / columns}% - ${gap}px)`;

  flexItems.forEach((item) => {
    item.style.flex = `0 0 ${width}`;
  });
}

function adjustFlexItemWidth() {
  const viewportWidth = window.innerWidth;
  const maxColumns = viewportWidth < 768 ? 2 : 4;

  setFlexItemWidth(maxColumns);

  return true;
}

function setOutOfStockText() {
  const textNode = document.createTextNode("Out of Stock");
  const targetDiv = document.querySelector("div.km-darkgrey");

  if (targetDiv && !targetDiv.classList.contains("out-of-stock-appended")) {
    targetDiv.appendChild(textNode);
    targetDiv.classList.add("out-of-stock-appended");
    return true;
  }
}

const intervalId = setInterval(
  () => {
    if (window.innerWidth <= 768) {
      const progress1OutOf4 = document.querySelector('img[alt="progress-bar-1-4"]');
      const progress2OutOf4 = document.querySelector('img[alt="progress-bar-2-4"]');
      const progress3OutOf4 = document.querySelector('img[alt="progress-bar-3-4"]');
      const progress4OutOf4 = document.querySelector('img[alt="progress-bar-4-4"]');

      const progress1OutOf5 = document.querySelector('img[alt="progress-bar-1-5"]');
      const progress2OutOf5 = document.querySelector('img[alt="progress-bar-2-5"]');
      const progress3OutOf5 = document.querySelector('img[alt="progress-bar-3-5"]');
      const progress4OutOf5 = document.querySelector('img[alt="progress-bar-4-5"]');
      const progress5OutOf5 = document.querySelector('img[alt="progress-bar-5-5"]');

      const progress1OutOf6 = document.querySelector('img[alt="progress-bar-1-6"]');
      const progress2OutOf6 = document.querySelector('img[alt="progress-bar-2-6"]');
      const progress3OutOf6 = document.querySelector('img[alt="progress-bar-3-6"]');
      const progress4OutOf6 = document.querySelector('img[alt="progress-bar-4-6"]');
      const progress5OutOf6 = document.querySelector('img[alt="progress-bar-5-6"]');
      const progress6OutOf6 = document.querySelector('img[alt="progress-bar-6-6"]');

      switch (true) {
        //1-4
        case !!progress1OutOf4:
          progress1OutOf4.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q1_of_4.jpg?v=1679078084";
          break;
        case !!progress2OutOf4:
          progress2OutOf4.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q2_of_4.jpg?v=1679078637";
          break;
        case !!progress3OutOf4:
          progress3OutOf4.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q3_of_4.jpg?v=1679078637";
          break;
        case !!progress4OutOf4:
          progress4OutOf4.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q4_of_4.jpg?v=1679078637";
          break;

        //1-5
        case !!progress1OutOf5:
          progress1OutOf5.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q1_of_5.jpg?v=1679079816";
          break;
        case !!progress2OutOf5:
          progress2OutOf5.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q2_of_5.jpg?v=1679078637";
          break;
        case !!progress3OutOf5:
          progress3OutOf5.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q3_of_5.jpg?v=1679078637";
          break;
        case !!progress4OutOf5:
          progress4OutOf5.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q4_of_5.jpg?v=1679078637";
          break;
        case !!progress5OutOf5:
          progress5OutOf5.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q5_of_5.jpg?v=1679078637";
          break;

        //1-6
        case !!progress1OutOf6:
          progress1OutOf6.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q1_of_6.jpg?v=1679080058";
          break;
        case !!progress2OutOf6:
          progress2OutOf6.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q2_of_6.jpg?v=1679078637";
          break;
        case !!progress3OutOf6:
          progress3OutOf6.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q3_of_6.jpg?v=1679078637";
          break;
        case !!progress4OutOf6:
          progress4OutOf6.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q4_of_6.jpg?v=1679078637";
          break;
        case !!progress5OutOf6:
          progress5OutOf6.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q5_of_6.jpg?v=1679078637";
          break;
        case !!progress6OutOf6:
          progress6OutOf6.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/q6_of_6.jpg?v=1679078637";
          break;
      }
    }

    const resultPageWrapper = document.querySelector(".oct-quiz-wrapper--result-page");

    if (resultPageWrapper) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      const adjustFlexWidthResult = adjustFlexItemWidth();
      const outOfStockTextResult = setOutOfStockText();

      if (window.innerWidth <= 768) {
        const resultBanner1 = document.querySelector('img[alt="result-banner-1"]');
        const resultBanner2 = document.querySelector('img[alt="result-banner-2"]');
        const resultBanner3 = document.querySelector('img[alt="result-banner-3"]');
        const resultBanner4 = document.querySelector('img[alt="result-banner-4"]');
        const resultBanner5 = document.querySelector('img[alt="result-banner-5"]');
        const resultBanner6 = document.querySelector('img[alt="result-banner-6"]');
        const resultBanner7 = document.querySelector('img[alt="result-banner-7"]');
        const resultBanner8 = document.querySelector('img[alt="result-banner-8"]');
        const resultBanner9 = document.querySelector('img[alt="result-banner-9"]');
        const resultBanner10 = document.querySelector('img[alt="result-banner-10"]');
        const resultBanner11 = document.querySelector('img[alt="result-banner-11"]');
        const resultBanner12 = document.querySelector('img[alt="result-banner-12"]');
        const resultBanner13 = document.querySelector('img[alt="result-banner-13"]');
        const resultBanner14 = document.querySelector('img[alt="result-banner-14"]');
        const resultBanner15 = document.querySelector('img[alt="result-banner-15"]');
        const resultBanner16 = document.querySelector('img[alt="result-banner-16"]');
        const resultBanner17 = document.querySelector('img[alt="result-banner-17"]');
        const resultBanner18 = document.querySelector('img[alt="result-banner-18"]');
        const resultBanner19 = document.querySelector('img[alt="result-banner-19"]');

        const customerReview = document.querySelector('img[alt="customer-review"]');
        const evolvedIndustry = document.querySelector('img[alt="evolved-industry"]');

        switch (true) {
          case !!resultBanner1:
            resultBanner1.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/strug_add_musc-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner2:
            resultBanner2.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/diff_leaning-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner3:
            resultBanner3.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/lacking_intense-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner4:
            resultBanner4.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/less_than_2-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner5:
            resultBanner5.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/3_to_5-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner6:
            resultBanner6.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/6_to_8-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner7:
            resultBanner7.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/6_to_8-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner8:
            resultBanner8.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/diff_finishing_workouts-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner9:
            resultBanner9.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/very_sore_male_not_enough_sleep-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner10:
            resultBanner10.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/Sore_between_workouts_enough_sleep-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner11:
            resultBanner11.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/Lose_weight_keep_off_Male-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner12:
            resultBanner12.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/knowing_right_nutrition-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner13:
            resultBanner13.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/enough_to_see_changesMale-mobile.jpg?v=1679064420";

            break;
          case !!resultBanner14:
            resultBanner14.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/focus_AM-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner15:
            resultBanner15.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/Focus_PM-mobile.jpg?v=1679064420";

            break;
          case !!resultBanner16:
            resultBanner16.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/Focus_Evening-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner17:
            resultBanner17.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/very_sore_male_not_enough_sleep-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner18:
            resultBanner18.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/very_sore_male_not_enough_sleep-mobile.jpg?v=1679064419";

            break;
          case !!resultBanner19:
            resultBanner19.src =
              "https://cdn.shopify.com/s/files/1/1110/3248/files/Wellbeing-mobile.jpg?v=1679064419";

            break;
        }

        if (customerReview) {
          customerReview.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/reviews-mobile.jpg?v=1679072589";
        }

        if (evolvedIndustry) {
          evolvedIndustry.src =
            "https://cdn.shopify.com/s/files/1/1110/3248/files/Highlights-mobile.jpg?v=1679072589";
        }

        if (resultPageWrapper && customerReview && evolvedIndustry) {
          clearInterval(intervalId);
        } else if (adjustFlexWidthResult && outOfStockTextResult) {
          clearInterval(intervalId);
        }
      }
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    }
  },
  500
);

/* Custom JS for Reward faqs */
document.addEventListener("DOMContentLoaded", () => {
  const summaries = document.querySelectorAll(".faq summary");

  summaries.forEach((summary) => {
    const icon = summary.parentNode.querySelector(".items-center .justify-center");
    if (icon) {
      icon.querySelector(":nth-child(1)").style.transform = "rotate(90deg)"; // "+" icon
      icon.querySelector(":nth-child(2)").style.transform = "rotate(0deg)";
    }

    const contentDiv = summary.nextElementSibling;
    if (contentDiv) {
      contentDiv.style.maxHeight = "0"; // Start with maxHeight set to 0
    }

    const clonedSummary = summary.cloneNode(true);
    summary.parentNode.replaceChild(clonedSummary, summary);
  });

  document.body.addEventListener("click", (event) => {
    const summary = event.target.closest('.faq summary');
    if (summary) {
      handleSummaryClick(event, summary);
    }
  });
});

function handleSummaryClick(event, summary) {
  event.preventDefault();

  const currentDetail = summary.parentNode;
  const contentDiv = summary.nextElementSibling;
  const isOpen = currentDetail.open;

  document.querySelectorAll(".faq details").forEach((detail) => {
    const icon = detail.querySelector(".items-center .justify-center");
    const otherContentDiv = detail.querySelector("summary + div");

    if (detail !== currentDetail) {
      // Close other details
      detail.open = false;
      otherContentDiv.style.maxHeight = "0";
      if (icon) {
        icon.querySelector(":nth-child(1)").style.transform = "rotate(90deg)"; 
        icon.querySelector(":nth-child(2)").style.transform = "rotate(0deg)";
      }
    }
  });

  if (!isOpen) {
   
    currentDetail.open = true;
   
    contentDiv.style.maxHeight = contentDiv.scrollHeight + "px";
  } else {
   
    contentDiv.style.maxHeight = "0";
  
    setTimeout(() => {
      currentDetail.open = false;
    }, 300); 
  }

  const icon = currentDetail.querySelector(".items-center .justify-center");
  if (icon) {
    icon.querySelector(":nth-child(1)").style.transform = isOpen ? "rotate(90deg)" : "rotate(0deg)";
    icon.querySelector(":nth-child(2)").style.transform = isOpen ? "rotate(0deg)" : "rotate(0deg)";
  }
}




/* Custom JS for mobile Nav */
const acc = document.getElementsByClassName("pf-mobile-nav-accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

const mobile_nav = document.getElementsByClassName("js-mobile-item");
var i;
for (i = 0; i < mobile_nav.length; i++) {
  // console.log(mobile_nav[i]);
  mobile_nav[i].addEventListener("click", function () {
    console.log("click");
    this.closest(".js-mobile-nav").classList.toggle("item-active");
  });
}

